import classNames from 'classnames';
import React, { useEffect } from 'react';

export default function Popup({
  children,
  isOpen,
  bodyClassNames,
}: {
  isOpen: boolean;
  children?: React.ReactNode;
  bodyClassNames?: any;
}) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (isOpen) {
      const scrollY = window.scrollY;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);
  return (
    <div
      className={`duration-250 fixed inset-0 z-[9999] lg:z-50 flex items-center justify-center transition-opacity ${
        isOpen ? 'visible opacity-100' : 'invisible opacity-0'
      }`}
    >
      <div
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm "
        onClick={(e) => {
          e.stopPropagation();
        }}
      ></div>

      <div
        className={classNames('relative z-10 w-full bg-white', bodyClassNames)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </div>
  );
}


